export default "__VITE_PUBLIC_ASSET__a58d32cb__"